import {
  ACTION_FETCH_INVOICES,
  ACTION_FETCH_INVOICES_PAGING,
} from '@/store/actions.type';
import {
  MUTATION_SET_INVOICES,
  MUTATION_SET_INVOICES_PAGING,
} from '@/store/mutations.type';

import InvoiceProxy from '@/proxies/invoice.proxy';

const state = {
  invoices: [],
  pagingInvoices: {},
};

const getters = {
  invoices: (state) => state.invoices,
  pagingInvoices: (state) => state.pagingInvoices,
};

const actions = {
  [ACTION_FETCH_INVOICES](state, query) {
    return InvoiceProxy.invoices(query).then((res) => {
      state.commit(MUTATION_SET_INVOICES, res.data);
    });
  },
  [ACTION_FETCH_INVOICES_PAGING](state, query) {
    return InvoiceProxy.invoicesPaging(query).then((res) => {
      state.commit(MUTATION_SET_INVOICES_PAGING, res.data);
      return res.data;
    });
  },
};

const mutations = {
  [MUTATION_SET_INVOICES](state, invoices) {
    state.invoices = invoices;
  },
  [MUTATION_SET_INVOICES_PAGING](state, paging) {
    state.pagingInvoices = paging;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
